<template>
  <div class="defaultText mb-8">
    <div class="title max-w-3xl mx-auto">
      <!-- <h1 class="font-semibold mb-6 text-center text-base md:text-lg textColorBlack">
        <span v-if="!stepNum">確認購買明細</span>
        <span v-if="stepNum === 'step2'">填寫訂購資訊</span>
        <span v-if="stepNum === 'step3'">訂單結算&amp;確認</span>
      </h1> -->
      <ul class="cart-steps flex text-base md:text-base flex-col md:flex-row md:justify-center px-2">
        <li class="steps_1 md:text-center" :class="{setpActive: !stepNum}">
          <div class="stepImg mb-3 w-24 h-24 mx-auto px-3 flex items-center justify-center">
            <progressive-img :src="step1.notOn" :class="{ hidden: !stepNum }" />
            <progressive-img :src="step1.on" :class="{ block: !stepNum }" class="hidden" />
            <!-- <div class="h-full w-full step1 all_img" :class="{ hidden: !stepNum }"></div>
            <div class="h-full w-full step1_on all_img hidden" :class="{ block: !stepNum }"></div> -->
          </div>
          <span class="inline-block textColorBlack text-sm lg:text-base md:hidden">Step1&ensp;確認購買明細</span>
          <span class="textColorBlack text-sm lg:text-base hidden md:block">Step1</span>
          <span class="textColorBlack text-sm lg:text-base hidden md:block">確認購買明細</span>
        </li>
        <li class="items-center mx-8 lg:mx-10 hidden md:flex">
          <font-awesome-icon icon="chevron-right" class="textColorDarkBlack" />
        </li>
        <li class="steps_2 md:text-center" :class="{setpActive: stepNum === 'step2'}">
          <div class="stepImg mb-3 w-24 h-24 mx-auto px-3 flex items-center justify-center">
            <progressive-img :src="step2.notOn"  :class="{hidden: stepNum === 'step2'}" />
            <progressive-img :src="step2.on" :class="{block: stepNum === 'step2'}" class="hidden" />
            <!-- <div class="h-full w-full step2 all_img" :class="{hidden: stepNum === 'step2'}"></div>
            <div class="h-full w-full step2_on all_img hidden" :class="{block: stepNum === 'step2'}"></div> -->
          </div>
          <span class="inline-block textColorBlack text-sm lg:text-base md:hidden">Step2&ensp;填寫訂購資訊</span>
          <span class="textColorBlack text-sm lg:text-base hidden md:block">Step2</span>
          <span  class="textColorBlack text-sm lg:text-base hidden md:block">填寫訂購資訊</span>
        </li>
        <li class="items-center mx-8 lg:mx-10 hidden md:flex">
          <font-awesome-icon icon="chevron-right" class="textColorDarkBlack" />
        </li>
        <li class="steps_2 md:text-center" :class="{setpActive: stepNum === 'step3'}">
          <div class="stepImg mb-3 w-24 h-24 mx-auto px-3 flex items-center justify-center">
            <progressive-img :src="step3.notOn"  :class="{hidden: stepNum === 'step3'}" />
            <progressive-img :src="step3.on" :class="{block: stepNum === 'step3'}" class="hidden" />
          </div>
          <span class="inline-block textColorBlack text-sm lg:text-base md:hidden">Step3&ensp;訂單結算&amp;確認</span>
          <span class="textColorBlack text-sm lg:text-base hidden md:block">Step3</span>
          <span  class="textColorBlack text-sm lg:text-base hidden  md:block">訂單結算&amp;確認</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Breadcrumb',

  props: {
    stepNum: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      step1: {
        notOn: require('@/assets/icon/check_off.svg'),
        on: require('@/assets/icon/check_on.svg')
      },
      step2: {
        notOn: require('@/assets/icon/pay_off.svg'),
        on: require('@/assets/icon/pay-on.svg')
      },
      step3: {
        notOn: require('@/assets/icon/final_off.svg'),
        on: require('@/assets/icon/final-on.svg')
      }
    }
  },
  computed: {
    ...mapGetters([
      'authorized',
      'user'
    ])
  }
}
</script>

<style lang="scss" scoped>
.block {
  display: block !important;
}
  @media (max-width: 767px) {
    .cart-steps {
      span {
        border-left: 3px solid #cacaca;
        line-height: 24px;
        padding-left: 8px;
        border-bottom: 0 !important;
      }
      .stepImg {
        display: none !important;
      }
      .setpActive span {
        border-left: 3px solid #000000;
      }
    }
  }
</style>
